<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-img
        :src="require('@/assets/maid.png')"
        contain
        max-width="300"
        min-height="78"
        width="100%"
        class="logo-filter"
      />
      <br />
      <base-title
        size="body-1"
        space="4"
        title="Kenwyn Maids Inc"
        weight="regular"
      />

      <base-body>License No.: NOLICENSE001</base-body>
      <base-btn class="mb-12" color="white" outlined href="/privacy-policy">
        Privacy Policy
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean,
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "Kenwyn Accounting and IT Services Pte. Ltd . <br>No 28,Riverside Road ,<br> Singapore 739085",
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+65-97223997",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@kenwynaccounting.com",
      },
    ],
  }),
};
</script>

<style scoped>
.logo-filter {
  filter: grayscale(100%);
}
</style>
